import { Editor as SlateEditor } from 'slate';

import {
  getCharactersPointsBoundaries,
  getParagraphsCharacterPoints,
  getSlateTopLevelNodes,
} from 'src/lib/slate';

const getCharBoundaries = (charsData, paragraph, start, end) => {
  const paragraphChars = charsData[paragraph];
  if (!paragraphChars || paragraphChars.length === 0 || !(start >= 0 && end >= 0)) {
    return null;
  }

  return getCharactersPointsBoundaries(paragraphChars, start, end);
};

export const contentMarkupToRangeRefs = ({ editor, markup }, options = null) => {
  if (!markup || markup.length === 0) {
    return [];
  }

  const result = [];
  const paragraphs = getSlateTopLevelNodes(editor);
  const charsData = getParagraphsCharacterPoints({ editor, paragraphs: [...paragraphs] }, options);

  markup.forEach(({ type, paragraph, start, end }) => {
    const boundaries = getCharBoundaries(charsData, paragraph, start, end);
    if (!boundaries?.start || !boundaries.end) {
      return;
    }

    const rangeRef = SlateEditor.rangeRef(
      editor,
      {
        anchor: boundaries.start,
        focus: boundaries.end,
        decoration: type,
      },
      { affinity: 'inward' }
    );
    result.push(rangeRef);
  });

  return result;
};
